// features/devices/devicesSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    limit: 2,
    selectedDevices: [],
    show: true
};

const { reducer, actions } = createSlice({
    name: 'popups',
    initialState,
    reducers: {
        setLimit(state, action) {
            state.limit = action.payload;

            // Trim if array is bigger than new limit
            if (state.selectedDevices.length > state.limit) {
                state.selectedDevices = state.selectedDevices.slice(0, state.limit);
            }
        },
        pushDevice(state, action) {
            const deviceId = action.payload;

            // If already present → do nothing
            if (state.selectedDevices.includes(deviceId)) {
                return;
            }

            // Add to front
            state.selectedDevices.unshift(deviceId);

            // Trim to limit
            if (state.selectedDevices.length > state.limit) {
                state.selectedDevices = state.selectedDevices.slice(0, state.limit);
            }
        },
        popDevice(state) {
            state.selectedDevices.shift();
        },
        clearDevices(state) {
            state.selectedDevices = [];
        },
        setShow(state, action) {
            state.show = action.payload;
        }
    }
});

// export const { setLimit, pushDevice, clearDevices } = devicesSlice.actions;
// export default devicesSlice.reducer;

export { actions as popupsActions, reducer as popupsReducer };

